import React from 'react';
import { Link } from 'react-router-dom';

/** Final CTA — source: mockup L600–611. */
const FinalCta = (): React.JSX.Element => (
  <section className="oq-final-cta">
    <div className="oq-container oq-final-cta__inner">
      <h2 className="oq-final-cta__title oq-bebas">
        Ready to give your club<br />
        its own app?
      </h2>
      <p className="oq-final-cta__subtitle">
        Book a 20-minute demo. We&apos;ll show you Olympiq with your club&apos;s branding, and map
        out getting your members across.
      </p>
      <div className="oq-final-cta__ctas">
        <Link to="/contact-us" className="oq-final-cta__cta-primary">Book a demo</Link>
        <Link to="/help-centre" className="oq-final-cta__cta-secondary">Browse the help centre</Link>
      </div>
    </div>
  </section>
);

export default FinalCta;
